export const LeadsMortgagesPermissions = {
  ViewMortgageLeads: {
    components: null,
    componentsId: null,
    permissionsId: "f2ff0924-c55a-4bc8-f5ba-08da8ab4c335",
    permissionsName: "View Mortgage Leads",
  },

  SendToRotation: {
    permissionsId: "66ef17c5-1e15-4358-839b-08db0f594284",
    permissionsName: "Send To Rotation",
    componentsId: null,
    components: null,
  },
  AddNewActivity: {
    permissionsId: "51b0d7ea-5481-4eb6-2877-08dbaf79a1bb",
    permissionsName: "Add New Activity",
    description: null,
    componentsId: null,
    components: null,
  },
  sendToLeadPool: {
    permissionsId: "d305d07c-6746-4686-c4c5-08dc683b0c43",
    permissionsName: "Send To The Leads Pool",
    description: null,
    componentsId: null,
    components: null,
  },
  sendToLeadPoolAssets: {
    permissionsId: "aad043bc-810f-4b01-5070-08dce2e2dc64",
    permissionsName: "Send To The Leads Pool (Assets)",
    description: null,
    componentsId: null,
    components: null,
  },
  EditContactName: {
    permissionsId: "6176e2e4-f632-42db-ec32-08dd2fb527c1",
    permissionsName: "Edit Contact Name",
    description: null,
    componentsId: null,
    components: null,
  },
  UpdateSaleType: {
    permissionsId: "96b34ce6-9ba5-4220-d91d-08dd66bd7136",
    permissionsName: "Update Sale Type",
    description: null,
    componentsId: null,
    components: null,
  },
  ViewLeadHistory: {
    permissionsId: "5fb688ba-dede-4c0f-f02a-08dd7fd1311c",
    permissionsName: "View Lead History",
    description: null,
    componentsId: null,
    components: null,
  },
  ArchiveLead: {
    permissionsId: "2c73eef5-028f-4ff2-a6ed-266fac5a1194",
    permissionsName: "Archive Lead",
    description: null,
    componentsId: null,
    components: null,
  },

  CanSkipLeadActivityValidation: {
    permissionsId: "f7ee1fad-5664-4ce0-b0ee-187bf112cebf",
    permissionsName: "can Skip Lead Activity Validation",
    description: null,
    componentsId: null,
    components: null,
  },

  CanSkipLeadDraftUnitValidation: {
    permissionsId: "6dbfffc0-82aa-482f-8ce0-b089a7dd0513",
    permissionsName: "can Skip Lead Draft Unit Validation",
    description: null,
    componentsId: null,
    components: null,
  },
  ShareToLeadXchangePool: {
    permissionsId: "75187887-2cd2-4ac5-ba12-5da3fcb0af02",
    permissionsName: "AllowUserToShareLead",
    description: null,
    componentsId: null,
    components: null,
  },
};
